import {createSelector} from 'reselect';

import {ConnectionStatus, UpdateSWStatusType} from '@/constants/dataEnum';

import {getConnState} from './signalRSelector';
import {getUpdateSWStatus} from './updateSystemSelector';

export const getLoadingState = (state) => state.loadingState;
export const getLoadingStore = (state) => state.loadingStore;

export const getLoading = createSelector([getLoadingState], (loadingState) => loadingState);
export const getLoadingPage = createSelector(
  [getLoading, getConnState, getUpdateSWStatus],
  (loading, connState, updateSWStatus) => {
    let {show, text} = loading;

    let showRestartService = false;

    switch (connState) {
      case ConnectionStatus.IDLE:
      case ConnectionStatus.CONNECTED:
        break;
      case ConnectionStatus.ERROR:
      case ConnectionStatus.CLOSE:
        show = true;

        switch (updateSWStatus) {
          case UpdateSWStatusType.IDLE:
            text = 'loading.hub.connectionClosed.message';
            showRestartService = true;
            break;
          case UpdateSWStatusType.FAILED:
            text = 'loading.systemUpdate.updateFailed.message';
            showRestartService = true;
            break;
          default:
            break;
        }

        break;
      case ConnectionStatus.RECONNECTING:
        show = true;
        switch (updateSWStatus) {
          case UpdateSWStatusType.IDLE:
            text = 'loading.hub.reconnecting.message';
            break;
          default:
            break;
        }

        break;
      default:
        break;
    }

    return {
      show,
      text,
      // isIntlFormat,
      showRestartService,
    };
  },
);

export const getMainLoadingPage = createSelector(
  [getLoadingStore, getConnState, getUpdateSWStatus],
  (loadingStore, connState, updateSWStatus) => {
    let {showLoading: show, loadingText: text} = loadingStore;

    let showRestartService = false;

    switch (connState) {
      case ConnectionStatus.IDLE:
      case ConnectionStatus.CONNECTED:
        break;
      case ConnectionStatus.ERROR:
      case ConnectionStatus.CLOSE:
        show = true;

        switch (updateSWStatus) {
          case UpdateSWStatusType.IDLE:
            text = 'loading.hub.connectionClosed.message';
            showRestartService = true;
            break;
          case UpdateSWStatusType.FAILED:
            text = 'loading.systemUpdate.updateFailed.message';
            showRestartService = true;
            break;
          default:
            break;
        }

        break;
      case ConnectionStatus.RECONNECTING:
        show = true;
        switch (updateSWStatus) {
          case UpdateSWStatusType.IDLE:
            text = 'loading.hub.reconnecting.message';
            break;
          default:
            break;
        }

        break;
      default:
        break;
    }

    return {
      isActive: show,
      loadingText: text || 'Loading... Please wait ! ',
      loadingClickEvent: loadingStore.loadingClickEvent,
      loadingButton1: loadingStore.loadingButton1,
      loadingButton2: loadingStore.loadingButton2,
      showRestartService,

      // {
      //     label : "SKIP",
      //     onClick: ()=>{ConsoleLog ("OnClick")}
      //     }//store.setupStore.loadingButton
    };
  },
);
